import { Alert, Button, Form, Input, Row, Col } from "antd";

import axios from "axios";
import { API_URL } from "../config/api";
import { useState } from "react";

// const formItemLayout = {
//     // @ts-ignore
//     // layout: FormLay,
//     layout: 'vertical' as FormLayout,
//     width: "100%",
//     labelCol: {
//         xs: { span: 24 },
//         // sm: { span: 6 },

//     },
//     wrapperCol: {
//         xs: { span: 24 },
//         // sm: { span: 14 },
//     },
// };

/*
Meno a priezvisko
E-mail
Telefonne cislo
Otazka, poznamka

After sending: loading and success message, and change to form to a success message
*/

export const ContactForm: any = (props: any) => {
  const { listing } = props;

  const [isSent, setSent] = useState(false);

  const handleFinish = async (data: any) => {
    const { _id } = listing;

    const mergedData = {
      ...data,
      ...listing,
      listingId: _id,
      email: "email: " + data.email,
    };

    // https://nodejs-production-8b99.up.railway.app
    await axios
      .post(`${API_URL}/contact-form`, mergedData)
      .then(async (res) => {
        console.log("The response is ", res);
        // Assuming res.data contains the URL of the uploaded image
      })
      .catch((err) => {
        console.log("The error is ", err);
      });
    setSent(true);
  };

  if (isSent) {
    return (
      <Alert
        message="Ďakujeme, v blízkej dobe Vás bude kontaktovať náš realitný agent: Zoltán Dobos (+421 905 738 632)"
        type="success"
      />
    );
  }

  if (!isSent)
    return (
      <Form
        layout="vertical"
        onFinish={handleFinish}
        autoComplete="off"
        style={{ width: "100%" }}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Meno a priezvisko"
              name="name"
              rules={[{ required: true, message: "Vyplňte!" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Telefónne číslo"
              name="phoneNumber"
              rules={[{ required: true, message: "Vyplňte!" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item label="E-mail" name="email">
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Otázka/poznámka (nepovinné)" name="note">
              <Input.TextArea rows={4} placeholder="Napíšte správu" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  backgroundColor: "#a08e50",
                  borderColor: "#a08e50",
                  borderRadius: 6,
                  padding: "0 2rem",
                  height: "40px",
                }}
              >
                Odoslať
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
};
